import { PropsWithChildren, ReactNode } from "react";
import MenuFilters from "./MenuFilters";

export type ItemProps = {
  component: ReactNode;
  onlyMobile?: boolean;
  wrappedComponent?: ReactNode;
  name?: string;
};

export type ExpandedFiltersProps = {
  items: ItemProps[];
  activeFilters?: number;
};

const Content = ({ items }: { items: ItemProps[] }) => {
  return (
    <div className="flex flex-col pt-6 sm:pt-0 lg:pt-6 pb-6">
      {items.map((item: ItemProps, i: number) => (
        <div
          className={`${item.onlyMobile ? "block sm:hidden" : ""} w-full ${i < items.length - 1 ? "mb-6" : ""}`}
          key={i}
        >
          {item.component}
        </div>
      ))}
    </div>
  );
};

export default function ExpandedFilters(props: PropsWithChildren<ExpandedFiltersProps>) {
  const { items, activeFilters } = props;

  // Don't render anything if there are no items
  if (!items || items.length === 0) {
    return null;
  }

  return <MenuFilters content={<Content items={items} />} activeFilters={activeFilters} />;
}
